export default __webpack_public_path__ + "static/media/log-out.06802fb9.png";